import React from 'react';
import PropTypes from 'prop-types';

import { useTranslation } from '@common/hooks/translation';
import Timer from '@common/components/timer';

const CASHOUT_POPUP_TIMER = 10;

const CashoutPopup = ({ defer, cashoutAmount }) => {
  const t = useTranslation();

  return (
    <div className="popup-content popup-small">
      <h3 className="popup-title">{t('Cashout')}</h3>
      <div className="popup-main-content">
        <i className="global-icon icon-cashout cashout-icon" />
        <p className="text-center">{t('Amount has been changed')}</p>
        <p className="text-center">{`${t('Would you like to cash out')} ${cashoutAmount} ?`}</p>
        <Timer onFinish={() => defer.resolve(false)} duration={CASHOUT_POPUP_TIMER} />
      </div>
      <div className="popup-actions">
        <button
          type="button"
          onClick={defer.resolve(false)}
          className="popup-cancel-button"
        >
          {t('Cancel')}
        </button>
        <button
          type="button"
          onClick={defer.resolve(true)}
          className="popup-confirm-button"
          disabled={cashoutAmount === 0}
        >
          {t('Cash out')}
        </button>
      </div>
    </div>
  );
};

export default CashoutPopup;

CashoutPopup.propTypes = {
  defer: PropTypes.object,
  cashoutAmount: PropTypes.number,
};
